import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './Results.css';
import { FavoriteEntityContainer } from '../../containers/FavoriteEntity';
import { PaginationContainer } from '../../containers/Pagination';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { ResultsEmptyForAuthorizationContainer } from '../../containers/ResultsEmptyForAuthorizationContainer';
import { EGetFavoriteEntitiesStatus, IResultsState } from '../../types/results';
import { ClientComment } from '../ClientComment';
import { Preloader } from '../Preloader';

export interface IResultsProps {
  results: IResultsState;
  foldersList: React.ReactNode;
  foldersHeader: React.ReactNode;
  topBar: React.ReactNode;
  isSearcherOrSub: boolean;
  isFavoritesForAuthorizationEnabled: boolean;
}

export const Results: React.FC<IResultsProps> = ({
  foldersList,
  foldersHeader,
  topBar,
  results,
  isSearcherOrSub,
  isFavoritesForAuthorizationEnabled,
}) => {
  const { favoriteEntities, status, clientCommentToFolder, editingNotes } = results;

  const renderFavorites = () => {
    if (favoriteEntities.length === 0) {
      return null;
    }

    if (isFavoritesForAuthorizationEnabled) {
      return <ResultsEmptyForAuthorizationContainer />;
    }

    return (
      <>
        {favoriteEntities.map((favoriteEntity, index) => {
          const { entityId } = favoriteEntity;

          return (
            <FavoriteEntityContainer
              key={`favoriteEntity_${entityId}`}
              isSearcherOrSub={isSearcherOrSub}
              favoriteEntity={favoriteEntity}
              position={index + 1}
              isEditComment={editingNotes.hasOwnProperty(entityId)}
              isFetchingComment={editingNotes[entityId] && editingNotes[entityId].isFetching}
            />
          );
        })}
      </>
    );
  };

  return (
    <div className={style['wrapper']}>
      <div className={style['container']}>
        {foldersList && <div className={style['folders']}>{foldersList}</div>}
        <div className={style['content']}>
          {foldersHeader && <div className={style['header']}>{foldersHeader}</div>}
          {topBar}
          {favoriteEntities.length === 0 && <ResultsEmptyContainer />}
          {renderFavorites()}
          <PaginationContainer />
          {clientCommentToFolder && (
            <div className={style['comment_to_folder']}>
              <UIHeading2>Комментарий к подборке</UIHeading2>
              <ClientComment text={clientCommentToFolder} />
            </div>
          )}
          {status === EGetFavoriteEntitiesStatus.Loading && (
            <div className={style['preloader']}>
              <Preloader size={64} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
